import { render, staticRenderFns } from "./ExpiringLicenses.vue?vue&type=template&id=0906f42b&scoped=true&"
import script from "./ExpiringLicenses.vue?vue&type=script&lang=js&"
export * from "./ExpiringLicenses.vue?vue&type=script&lang=js&"
import style0 from "./ExpiringLicenses.vue?vue&type=style&index=0&id=0906f42b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906f42b",
  null
  
)

export default component.exports